import * as firebase from 'firebase';

const config = {
	apiKey: "AIzaSyCCycLesKkFT4L-f4hGe7swN5ZeKJQXNko",
	authDomain: "grocery-app-1e802.firebaseapp.com",
	databaseURL: "https://grocery-app-1e802.firebaseio.com",
	projectId: "grocery-app-1e802",
	storageBucket: "grocery-app-1e802.appspot.com",
	messagingSenderId: "622799257022"
};

const app = firebase.initializeApp(config)
export { app }



// WEBPACK FOOTER //
// ./src/base.js